import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import {
  ALERT_MSGS,
  API_STATUS,
  DATA_META_CARDS,
  FEATURE_DRIFT_CARD,
  META_DATA_KEY_MAPPER,
} from "../../util/StaticData"
import AxiosOperations from "../../services/AxiosOperations"
import { API } from "../../util/api"
import { IFeatureDriftTableData, IMetaDataCard } from "../../util/interface"

const admData: any = []
const rawDataQualityData: any = []
const ccData: any = []
const isqData: any = []
const isprData: any = []
let admRawData: any
let isqRawData: any
let ccRawData: any
let rawDataQualityRawData: any
let isprRawData: any
const selectedRawDataRow: any = ""
const rawDataInfoTableData: any = []
const rawDataCSVData: any = []
const schemaDataCSVData: any = []
const rawProcessedDataCSVData: any = []
const dataDriftData: any = []
const featureDriftData: any = []

const dataDriftRawData: any = []
const featureDriftRawData: any = []
const featureDriftCardData = FEATURE_DRIFT_CARD
const statusMessages = {
  RDQ: "",
  AMC: "",
  ISPR: "",
  CC: "",
  ISQC: "",
  FD: "",
  DDC: "",
}
export const initialState = {
  status: API_STATUS.IDLE,
  rawDataQualityStatus: API_STATUS.IDLE,
  admStatus: API_STATUS.IDLE,
  ccStatus: API_STATUS.IDLE,
  isqStatus: API_STATUS.IDLE,
  dataDriftStatus: API_STATUS.IDLE,
  featureDriftStatus: API_STATUS.IDLE,
  dataDriftData,
  featureDriftData,
  dataDriftRawData,
  featureDriftRawData,
  featureDriftCardData,
  admData,
  selectedRawDataRow,
  ccData,
  isqData,
  rawDataQualityData,
  admRawData,
  isqRawData,
  ccRawData,
  isprRawData,
  rawDataQualityRawData,
  tabs: DATA_META_CARDS,
  activeTab: "RDQ",
  isprData,
  isprStatus: API_STATUS.IDLE,
  rawDataInfoTableData,
  rawDataInfoTableStatus: API_STATUS.IDLE,
  isRdqDetailsTableActive: false,
  selectedRawData: "",
  rawDataCSVData,
  rawProcessedDataCSVData,
  schemaDataCSVData,
  rawDataCSVDataStatus: API_STATUS.IDLE,
  schemaDataCSVDataStatus: API_STATUS.IDLE,
  rawProcessedDataCSVDataStatus: API_STATUS.IDLE,
  statusMessages,
}

export const rawDataQualityAsync = createAsyncThunk(
  "dataMetaData/rawDataQuality",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        run_id: state.filters.runIdSelectedValue,
        market_place: state.filters.marketSingleCaseSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RAW_DATA_QUALITY, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)
export const rawDataQualityInfoAsync = createAsyncThunk(
  "dataMetaData/rawDataQualityInfo",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        run_id: state.filters.runIdSelectedValue,
        market_place: state.filters.marketSingleCaseSelectedValue,
        raw_data_name: state.dataMetaData.selectedRawDataRow,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RAW_DATA_INFO, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const admAsync = createAsyncThunk(
  "dataMetaData/adm",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        file_type: "adm_mapping_check",
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.METADATA, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const dataDriftAsync = createAsyncThunk(
  "dataMetaData/dataDrift",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        file_type: "data_drift",
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.METADATA, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const featureDriftAsync = createAsyncThunk(
  "dataMetaData/featureDrift",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        file_type: "feature_drift",
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.METADATA, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const rawDataCSV = createAsyncThunk(
  "dataMetaData/raw-data/csv",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        file_type: "raw_data_quality",
        use_case: state.filters.useCaseSelectedValue,
        raw_data_file_type: "unique_and_not_null",
        marketplace: state.filters.marketSingleCaseSelectedValue,
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RAW_DATA_CSV_DOWNLOAD, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const schemaDataCSV = createAsyncThunk(
  "dataMetaData/schema-data/csv",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        file_type: "raw_data_quality",
        use_case: state.filters.useCaseSelectedValue,
        raw_data_file_type: "schema",
        marketplace: state.filters.marketSingleCaseSelectedValue,
        run_id: state.filters.runIdSelectedValue,
        raw_data_name: state.dataMetaData.selectedRawDataRow,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RAW_DATA_CSV_DOWNLOAD, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const rawProcessedDataCSV = createAsyncThunk(
  "dataMetaData/raw_processed-data/csv",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        file_type: "raw_data_quality",
        use_case: state.filters.useCaseSelectedValue,
        raw_data_file_type: "raw_processed",
        marketplace: state.filters.marketSingleCaseSelectedValue,
        run_id: state.filters.runIdSelectedValue,
        raw_data_name: state.dataMetaData.selectedRawDataRow,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.RAW_DATA_CSV_DOWNLOAD, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const ccAsync = createAsyncThunk(
  "dataMetaData/cc",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        file_type: "consistency_check",
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.METADATA, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const isqAsync = createAsyncThunk(
  "dataMetaData/isq",
  async (_, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        use_case: state.filters.useCaseSelectedValue,
        marketplace: state.filters.marketSingleCaseSelectedValue,
        file_type: "input_series_quality_check",
        run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.METADATA, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const emailTriggerAsync = createAsyncThunk(
  "dataMetaData/emailTrigger",
  async ({ file_type }: { file_type: string }, { getState }) => {
    try {
      const state: any = getState()
      const payload = {
        file_type,
        az_pipeline_run_id: state.filters.runIdSelectedValue,
      }
      const axiosObj = new AxiosOperations()
      return axiosObj.get(API.DATA_META_DATA_EMAIL_TRIGER, payload)
    } catch (error) {
      console.error("Error:", error)
    }
  },
)

export const dataMetaDataSlice = createSlice({
  name: "dataMetaData",
  initialState,
  reducers: {
    tabChange: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload
    },
    rowSlection: (state, action: PayloadAction<string>) => {
      state.selectedRawDataRow = action.payload
    },
    toggleRawDataDetails: (
      state,
      action: PayloadAction<{
        selectedRawData: string
        isRdqDetailsTableActive: boolean
      }>,
    ) => {
      state.isRdqDetailsTableActive = action.payload.isRdqDetailsTableActive
      state.selectedRawData = action.payload.selectedRawData
    },
    updateCardWithEmailTriggerInfo: (
      state,
      action: PayloadAction<{
        emailText: string
        key: string
        emailTrigger: boolean
      }>,
    ) => {
      state.tabs = state.tabs.map((obj: IMetaDataCard) => {
        if (obj.key === action.payload.key) {
          obj.emailTrigger = action.payload.emailTrigger
          obj.emailText = action.payload.emailText
        }
        return obj
      })
    },
    resetFullStateDataMetaData: () => {
      return structuredClone(initialState)
    },
    resetRawDataTable: (state) => {
      state.rawDataInfoTableData = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rawDataQualityAsync.pending, (state) => {
        state.rawDataQualityStatus = API_STATUS.LOADING
      })
      .addCase(rawDataQualityAsync.fulfilled, (state, action: any) => {
        try {
          state.rawDataQualityStatus = API_STATUS.IDLE
          state.rawDataQualityData = action["payload"]["data"]
          state.rawDataQualityRawData = action["payload"]["data"]
          const data = state.tabs
          const index = data.findIndex(
            (obj) => obj.key === META_DATA_KEY_MAPPER.RDQ,
          )
          data[index]["passCount"] = action["payload"]["passed"]
          data[index]["fail"] = action["payload"]["failed"]
          data[index]["progress"] = action["payload"]["percent_passed"]
          state.tabs = data
          state.statusMessages.RDQ = ""
        } catch (error) {
          state.rawDataQualityStatus = API_STATUS.FAILED
        }
      })
      .addCase(rawDataQualityAsync.rejected, (state) => {
        state.rawDataQualityStatus = API_STATUS.FAILED
        state.statusMessages.RDQ = reportNotAvailable()
        state.rawDataQualityData = []
        state.rawDataQualityRawData = []
        const index = state.tabs.findIndex(
          (obj) => obj.key === META_DATA_KEY_MAPPER.RDQ,
        )
        state.tabs = resetCardStatus(state.tabs, index)
      })
      .addCase(admAsync.pending, (state) => {
        state.admStatus = API_STATUS.LOADING
      })
      .addCase(admAsync.fulfilled, (state, action: any) => {
        try {
          state.admStatus = API_STATUS.IDLE
          state.admData = action["payload"]["data"]
          state.admRawData = action["payload"]["data"]
          const data = state.tabs
          const index = data.findIndex(
            (obj) => obj.key === META_DATA_KEY_MAPPER.AMC,
          )
          data[index]["passCount"] = action["payload"]["passed"]
          data[index]["fail"] = action["payload"]["failed"]
          data[index]["progress"] = action["payload"]["percent_passed"]
          state.tabs = data
          state.statusMessages.AMC = ""
        } catch (error) {
          state.admStatus = API_STATUS.FAILED
        }
      })
      .addCase(admAsync.rejected, (state) => {
        state.admStatus = API_STATUS.FAILED
        state.statusMessages.AMC = reportNotAvailable()
        state.admData = []
        state.admRawData = []
        const index = state.tabs.findIndex(
          (obj) => obj.key === META_DATA_KEY_MAPPER.AMC,
        )
        state.tabs = resetCardStatus(state.tabs, index)
      })
      .addCase(dataDriftAsync.pending, (state) => {
        state.dataDriftStatus = API_STATUS.LOADING
      })
      .addCase(dataDriftAsync.fulfilled, (state, action: any) => {
        try {
          state.dataDriftStatus = API_STATUS.IDLE
          // const keys = [
          //   "HARD_THRESHOLD_LOWER_LIMIT",
          //   "HARD_THRESHOLD_UPPER_LIMIT",
          //   "SOFT_THRESHOLD_LOWER_LIMIT",
          //   "SOFT_THRESHOLD_UPPER_LIMIT",
          // ]
          //Removing the duplicate limits
          // action["payload"]["data"] = action["payload"]["data"].filter(
          //   (obj: any) => {
          //     const valuesSet = new Set()
          //     for (const key of keys) {
          //       const value = obj[key]
          //       if (valuesSet.has(value)) {
          //         return false
          //       }
          //       valuesSet.add(value)
          //     }
          //     return true
          //   },
          // )
          state.dataDriftData = action["payload"]["data"]
          state.dataDriftRawData = action["payload"]["data"]
          const data = state.tabs
          const index = data.findIndex(
            (obj) => obj.key === META_DATA_KEY_MAPPER.DDC,
          )
          data[index]["passCount"] = action["payload"]["passed"]
          data[index]["fail"] = action["payload"]["failed"]
          data[index]["progress"] = action["payload"]["percent_passed"]
          state.tabs = data
          state.statusMessages.DDC = ""
        } catch (error) {
          state.dataDriftStatus = API_STATUS.FAILED
        }
      })
      .addCase(dataDriftAsync.rejected, (state) => {
        state.dataDriftStatus = API_STATUS.FAILED
        state.statusMessages.DDC = reportNotAvailable()
        state.dataDriftData = []
        state.dataDriftRawData = []
        const index = state.tabs.findIndex(
          (obj) => obj.key === META_DATA_KEY_MAPPER.DDC,
        )
        state.tabs = resetCardStatus(state.tabs, index)
      })
      .addCase(featureDriftAsync.pending, (state) => {
        state.featureDriftStatus = API_STATUS.LOADING
      })
      .addCase(featureDriftAsync.fulfilled, (state, action: any) => {
        try {
          state.featureDriftCardData.warnings = 0
          state.featureDriftCardData.progress = 0
          state.featureDriftStatus = API_STATUS.IDLE
          state.featureDriftRawData = action["payload"]["data"]
          state.featureDriftData = state.featureDriftRawData.map(
            (obj: IFeatureDriftTableData) => {
              obj.highlight = false
              if (
                obj.PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG >
                obj.WARNING_THRESHOLD
              ) {
                state.featureDriftCardData.warnings++
                obj.highlight = true
              }
              return obj
            },
          )
          state.featureDriftCardData.progress =
            state.featureDriftData.reduce(
              (accumulator: number, current: any) =>
                accumulator +
                current["PRECENTAGE_CHANGE_FROM_LAST_12MONTHS_AVG"],
              0,
            ) / state.featureDriftData.length

          state.featureDriftCardData.progress = Number(
            state.featureDriftCardData.progress.toFixed(2),
          )
          state.statusMessages.FD = ""
        } catch (error) {
          state.featureDriftStatus = API_STATUS.FAILED
        }
      })
      .addCase(featureDriftAsync.rejected, (state) => {
        state.featureDriftStatus = API_STATUS.FAILED
        state.statusMessages.FD = reportNotAvailable()
        state.featureDriftData = []
        state.featureDriftRawData = []
        state.featureDriftCardData.progress = 0
        state.featureDriftCardData.warnings = 0
        // const index = state.tabs.findIndex(
        //   (obj) => obj.key === META_DATA_KEY_MAPPER.FD,
        // )
        // state.tabs = resetCardStatus(state.tabs, index)
      })
      .addCase(rawDataCSV.pending, (state) => {
        state.rawDataCSVDataStatus = API_STATUS.LOADING
      })
      .addCase(rawDataCSV.fulfilled, (state, action: any) => {
        try {
          state.rawDataCSVData = action["payload"]
          state.rawDataCSVDataStatus = API_STATUS.IDLE
        } catch (error) {
          state.rawDataCSVDataStatus = API_STATUS.FAILED
        }
      })
      .addCase(rawDataCSV.rejected, (state) => {
        state.rawDataCSVDataStatus = API_STATUS.FAILED
      })
      .addCase(schemaDataCSV.pending, (state) => {
        state.schemaDataCSVDataStatus = API_STATUS.LOADING
      })
      .addCase(schemaDataCSV.fulfilled, (state, action: any) => {
        try {
          state.schemaDataCSVData = action["payload"]
          state.schemaDataCSVDataStatus = API_STATUS.IDLE
        } catch (error) {
          state.schemaDataCSVDataStatus = API_STATUS.FAILED
        }
      })
      .addCase(schemaDataCSV.rejected, (state) => {
        state.schemaDataCSVDataStatus = API_STATUS.FAILED
      })
      .addCase(rawProcessedDataCSV.pending, (state) => {
        state.rawProcessedDataCSVDataStatus = API_STATUS.LOADING
      })
      .addCase(rawProcessedDataCSV.fulfilled, (state, action: any) => {
        try {
          state.rawProcessedDataCSVData = action["payload"]
          state.rawProcessedDataCSVDataStatus = API_STATUS.IDLE
        } catch (error) {
          state.rawProcessedDataCSVDataStatus = API_STATUS.FAILED
        }
      })
      .addCase(rawProcessedDataCSV.rejected, (state) => {
        state.rawProcessedDataCSVDataStatus = API_STATUS.FAILED
      })
      .addCase(ccAsync.pending, (state) => {
        state.ccStatus = API_STATUS.LOADING
      })
      .addCase(ccAsync.fulfilled, (state, action: any) => {
        try {
          state.ccStatus = API_STATUS.IDLE
          action.payload.data = action.payload.data.map((obj: any) => {
            const [baseTableColumn, mappedTableColumn] =
              obj.QUALITY_CHECK_DESC.split(" ").filter(
                (str: string) => str === str.toUpperCase(),
              )
            obj["baseTableColumn"] = baseTableColumn
            obj["mappedTableColumn"] = mappedTableColumn
            return obj
          })
          state.ccData = action["payload"]["data"]
          state.ccRawData = action["payload"]["data"]
          const data = state.tabs
          const index = data.findIndex(
            (obj) => obj.key === META_DATA_KEY_MAPPER.CC,
          )
          data[index]["passCount"] = action["payload"]["passed"]
          data[index]["fail"] = action["payload"]["failed"]
          data[index]["progress"] = action["payload"]["percent_passed"]
          state.tabs = data
          state.statusMessages.CC = ""
        } catch (error) {
          state.ccStatus = API_STATUS.FAILED
        }
      })
      .addCase(ccAsync.rejected, (state) => {
        state.ccStatus = API_STATUS.FAILED
        state.statusMessages.CC = reportNotAvailable()
        state.ccData = []
        state.ccRawData = []
        const index = state.tabs.findIndex(
          (obj) => obj.key === META_DATA_KEY_MAPPER.CC,
        )
        state.tabs = resetCardStatus(state.tabs, index)
      })

      .addCase(isqAsync.pending, (state) => {
        state.isqStatus = API_STATUS.LOADING
      })
      .addCase(isqAsync.fulfilled, (state, action: any) => {
        try {
          state.isqStatus = API_STATUS.IDLE
          state.isqData = action["payload"]["data"]
          state.isqRawData = action["payload"]["data"]
          const data = state.tabs
          const index = data.findIndex(
            (obj) => obj.key === META_DATA_KEY_MAPPER.ISQC,
          )
          data[index]["passCount"] = action["payload"]["passed"]
          data[index]["fail"] = action["payload"]["failed"]
          data[index]["progress"] = action["payload"]["percent_passed"]
          state.tabs = data
          state.statusMessages.ISQC = ""
        } catch (error) {
          state.isqStatus = API_STATUS.FAILED
        }
      })
      .addCase(isqAsync.rejected, (state) => {
        state.statusMessages.ISQC = reportNotAvailable()
        state.isqStatus = API_STATUS.FAILED
        state.isqData = []
        state.isqRawData = []
        const index = state.tabs.findIndex(
          (obj) => obj.key === META_DATA_KEY_MAPPER.ISQC,
        )
        state.tabs = resetCardStatus(state.tabs, index)
      })
      .addCase(rawDataQualityInfoAsync.pending, (state) => {
        state.rawDataInfoTableStatus = API_STATUS.LOADING
      })
      .addCase(rawDataQualityInfoAsync.fulfilled, (state, action: any) => {
        try {
          state.rawDataInfoTableStatus = API_STATUS.IDLE
          state.rawDataInfoTableData = Object.keys(
            action["payload"]["data"][0],
          ).map((key) => {
            const temp = {
              ...action["payload"]["data"][0][key],
              column: key,
            }
            return temp
          })
        } catch (error) {
          state.rawDataInfoTableStatus = API_STATUS.FAILED
        }
      })
      .addCase(rawDataQualityInfoAsync.rejected, (state) => {
        state.rawDataInfoTableStatus = API_STATUS.FAILED
      })
  },
})
export const isqStatusSelector = (state: RootState) =>
  state.dataMetaData.isqStatus
export const isqDataSelector = (state: RootState) => state.dataMetaData.isqData
export const ddcDataSelector = (state: RootState) =>
  state.dataMetaData.dataDriftData
export const freatureDriftDataSelector = (state: RootState) =>
  state.dataMetaData.featureDriftData
export const ccStatusSelector = (state: RootState) =>
  state.dataMetaData.ccStatus
export const ccDataSelector = (state: RootState) => state.dataMetaData.ccData
export const admStatusSelector = (state: RootState) =>
  state.dataMetaData.admStatus
export const admDataSelector = (state: RootState) => state.dataMetaData.admData
export const rawDataQualityStatusSelector = (state: RootState) =>
  state.dataMetaData.rawDataQualityStatus
export const rawDataQualityDataSelector = (state: RootState) =>
  state.dataMetaData.rawDataQualityData
export const tabDataSelector = (state: RootState) => state.dataMetaData.tabs
export default dataMetaDataSlice.reducer

export const {
  tabChange,
  toggleRawDataDetails,
  rowSlection,
  resetFullStateDataMetaData,
  updateCardWithEmailTriggerInfo,
  resetRawDataTable,
} = dataMetaDataSlice.actions

function reportNotAvailable() {
  return `${ALERT_MSGS.DATA_META_DATA.REPORT_NOT_AVAILABLE}`
}

function resetCardStatus(data: any, index: number) {
  data[index]["passCount"] = 0
  data[index]["fail"] = 0
  data[index]["progress"] = 0
  return data
}
